import * as React from 'react';

function SvgDashSquareFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M2 0a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2zm2.5 7.5h7a.5.5 0 010 1h-7a.5.5 0 010-1z' />
		</svg>
	);
}

export default SvgDashSquareFill;
